<template>
  <div class="page-container">
    <div>
      <el-button v-if="!noContent" type="primary" @click="addOrUpdateHandle()">Add Business Specification</el-button>
    </div>
    <div class="el-list protocols-wrapper">
      <el-row v-loading="dataListLoading" :gutter="30">
        <el-col v-if="noContent">
          <el-empty description=" ">
            <el-button type="primary" @click="addOrUpdateHandle()">Add Business Specification</el-button>
          </el-empty>
        </el-col>
        <template v-if="!noContent">
          <el-col :span="6" v-for="item in dataList" :key="item.id">
            <el-card shadow="nerver" :body-style="{ padding: '0px' }" class="mt16 relative">
              <div class="module-item">
                <div class="module-desc">
                  <p class="item-wrap">
                    <span class="wd110 item-label">Country:</span>
                    <span class="item-content">{{ item.country }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd110 item-label">Business Type:</span>
                    <span class="item-content">{{ businessTypeFormat(item.businessType) }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd110 item-label">Update Time:</span>
                    <span class="item-content">{{ item.updateTime }}</span>
                  </p>
                </div>
              </div>
              <ul class="el-card-actions">
                <li class="wdb50" @click="deleteHandle(item)">
                  <svg-icon name="delete" class="fs16"></svg-icon>
                </li>
                <li class="wdb50" @click="addOrUpdateHandle(item)">
                  <svg-icon name="edit" class="fs16"></svg-icon>
                </li>
              </ul>
            </el-card>
          </el-col>
        </template>
      </el-row>
    </div>

    <!-- 新建或修改 = 弹窗 -->
    <add-or-update-dialog ref="addOrUpdateDialog" @update="getConfigList" />
  </div>
</template>

<script>
import AddOrUpdateDialog from "./modal/AddOrUpdate";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  components: {
    AddOrUpdateDialog,
  },
  data() {
    return {
      dataForm: {},
      dataList: [],
      dataListLoading: false,
    };
  },
  computed: {
    noContent() {
      return this.dataList.length === 0;
    },
  },
  methods: {
    // 获取配置列表
    async getConfigList(current) {
      this.dataListLoading = true;
      const params = {
        ...this.dataForm,
      };
      this.$http
        .get("/admin/stBusinessSpecification/getList", {
          params,
        })
        .then(res => {
          this.dataList = res.data || [];
        })
        .finally(() => {
          this.dataListLoading = false;
        });
    },
    // 删除
    async deleteHandle(row) {
      await this.$confirm(`Delete this Business Specification. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      this.$http.post(`/admin/stBusinessSpecification/${row.id}/delete`).then(res => {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            this.getConfigList();
          },
        });
      });
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdateDialog.init(row);
    },
  },
  activated() {
    this.getConfigList();
  },
};
</script>

<style lang="scss" scoped></style>
